<template>
  <transition-group
    tag="div"
    enter-active-class="animate__animated animate__backInLeft "
    leave-active-class="animate__animated animate__backOutLeft "
  >
    <div>
      <div v-if="member">{{ member.firstName }} {{ member.lastName }}</div>

      <button class="btn memRemoveBtn" v-on:click="removeFromGroup">
        Remove
      </button>
    </div></transition-group
  >
</template>

<script>
    export default {
         props: ['id', 'groupId'],

          data() {
            return {
              member: {},
              group: {}
            }
          },

           created () {
              this.member = this.$store.getters['members/members'].find(m => m.id === this.id) 
              this.group = this.$store.getters['groups/groups'].find(g => g.id === this.groupId)
          },
        

          methods: {
            removeFromGroup() {
              console.log('groupID', this.groupId)
              this.$store.dispatch('groups/removeFromGroup', {id: this.groupId, memberId: this.id})
              this.$store.dispatch('members/removeGroupFromMember', {memberId: this.id})
             
              this.group = this.$store.getters['groups/groups'].find(g => g.id === this.groupId)
            },
            async loadGroups() {
                  await this.$store.dispatch('groups/fetchGroups')

            },
           
                      }
         
     
    }
</script>

<style scoped>
.btn {
  background-color: cadetblue;
  color: #9a3f3f;
  padding: 0.5rem;
  border: none;
  border-radius: 0.3rem;
  width: 11em;
  font-size: 1em;
}
.box {
  width: 11em;
  height: 2em;
  border: 1px solid #999;
  font-size: 1em;
  color: white;
  background-color: cadetblue;
  border-radius: 5px;
}
.btnContainer {
  display: flex;
  justify-content: space-around;
  padding: 0.3rem;
}

.memberCard {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.memberCardTwo {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.memberList {
  width: 100%;
}

.memberCardTwo :nth-child(odd of .memberList) {
  background-color: blue;
}

.memRemoveBtn {
  background-color: #d29b9b;
}

li {
  list-style: none;
}

@media only screen and (max-width: 600px) {
  .memberCardTwo,
  .card {
    margin: 0 !important;
    padding: 0 !important;
  }

  .btn {
    width: inherit;
    padding: 0.5rem;
    margin: 0.2rem;
    width: 6rem;
  }
  .container {
    display: inline-block;
    padding-bottom: 1rem;
  }
}
</style>